var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5837 0H24.8625V22.63H21.5837V0ZM16.4262 16.175H19.705V19.3875H16.4262V16.175ZM16.4262 7.37875H19.705V14.1862H16.4262V7.37875ZM16.4262 21.375H19.705V28.1825H16.4262V21.375ZM6.00125 7.37H9.27875V30H6L6.00125 7.37ZM11.2675 10.5688H14.5462V13.7812H11.2687L11.2675 10.5688ZM11.2675 15.7575H14.5462V22.5662H11.2687L11.2675 15.7575ZM11.2675 1.77375H14.5462V8.58125H11.2687L11.2675 1.77375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.d76141803428f5f34d3125a125df7e81.svg";
export { ForwardRef as ReactComponent };